import React from 'react';
import {
  Box,
  Tooltip,
  IconButton,
  Divider,
} from '@mui/material';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import DownloadIcon from '@mui/icons-material/Download';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneEnabledOutlinedIcon from '@mui/icons-material/PhoneEnabledOutlined';
import ChatOutlinedIcon from '@mui/icons-material/ChatOutlined';

const Sidebar = () => {
  const contactOptions = [
    { 
      icon: <WhatsAppIcon />,
      color: '#25D366',
      bgColor: 'rgba(37, 211, 102, 0.1)',
      label: 'WhatsApp',
      href: 'https://wa.me/+0421653123'
    },
    { 
      icon: <EmailOutlinedIcon />,
      color: '#EA4335',
      bgColor: 'rgba(234, 67, 53, 0.1)',
      label: 'Email',
      href: 'mailto:enquiry@wtint.com'
    },
    { 
      icon: <PhoneEnabledOutlinedIcon />,
      color: '#4285F4',
      bgColor: 'rgba(66, 133, 244, 0.1)',
      label: 'Call',
      href: 'tel:+0421653123'
    }
  ];

  const quickActions = [
    { 
      icon: <DownloadIcon />,
      color: '#34A853',
      bgColor: 'rgba(52, 168, 83, 0.1)',
      label: 'Brochure', 
      href: '/brochures/company.pdf' 
    },
    { 
      icon: <ChatOutlinedIcon />,
      color: '#FBBC05',
      bgColor: 'rgba(251, 188, 5, 0.1)',
      label: 'Chat',
      href: '/chat'
    }
  ];

  return (
    <Box 
      sx={{
        position: 'fixed',
        top: '50%',
        right: 0,
        transform: 'translateY(-50%)',
        zIndex: 1200,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 1,
        bgcolor: 'rgba(255,255,255,0.9)',
        borderTopLeftRadius: 10,
        borderBottomLeftRadius: 10,
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
        p: 1,
        width: 60,
      }}
    >
      {contactOptions.map((option) => (
        <Tooltip key={option.label} title={option.label} placement="left">
          <IconButton
            href={option.href}
            target="_blank"
            sx={{
              color: option.color,
              transition: 'all 0.3s ease',
              '&:hover': {
                bgcolor: option.bgColor,
                transform: 'scale(1.1)',
              },
            }}
          >
            {option.icon}
          </IconButton>
        </Tooltip>
      ))}

      <Divider sx={{ width: '100%', my: 1 }} />

      {quickActions.map((action) => (
        <Tooltip key={action.label} title={action.label} placement="left">
          <IconButton
            href={action.href}
            sx={{
              color: action.color,
              transition: 'all 0.3s ease',
              '&:hover': {
                bgcolor: action.bgColor,
                transform: 'scale(1.1)',
              },
            }}
          >
            {action.icon}
          </IconButton>
        </Tooltip>
      ))}
    </Box>
  );
};

export default Sidebar; 